import React from 'react';
import { Col, Modal, ModalBody, Row } from 'react-bootstrap';
import ModalHeader from '../ModalHeader';
import Label from '../Label';
import Image from 'react-bootstrap/Image';
import Button from '../Button';

export type idCardModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
}>;

const IDCardModal = ({
  showModal = false,
  handleClose,
  ...props
}: idCardModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="xl">
      <ModalHeader closeButton>
        <h5>ID Card</h5>
      </ModalHeader>
      <ModalBody className="pt-9">
        <section>
          <Row className="justify-content-center">
            <Col className={'col-lg-6 col-12'}>
              <Label className={'lh-xs'}>
                <span className={'text-dark-gray-50'}>Front</span>
              </Label>
              <Image
                src={`${process.env.PUBLIC_URL}/front-id-card-image.png`}
                width={'100%'}
              />
            </Col>
            <Col className={'col-lg-6 col-12'}>
              <Label className={'lh-xs'}>
                <span className={'text-dark-gray-50'}>Back</span>
              </Label>
              <Image
                src={`${process.env.PUBLIC_URL}/back-id-card-image.png`}
                width={'100%'}
              />
            </Col>
            <Col className={'col-12 col-lg-4 mt-11 mb-11'}>
              <Button
                variant={'primary-outline'}
                className={'w-100'}
                onClick={() => handleClose()}
              >
                Close
              </Button>
            </Col>
          </Row>
        </section>
      </ModalBody>
    </Modal>
  );
};

export default IDCardModal;
